import { useListAuthorizationsQuery } from '../../redux/api'
import { AuthorizationEntry } from '../../sdk'
import useAccessTokenAndShopId from '../useAccessTokenAndShopId/useAccessTokenAndShopId'
import useAuthorizations from './useAuthorizations'

const useAuthorizationsById: (repairOrderId: string) => {
  sortedAuthorizations?: AuthorizationEntry[]
  previousTotal?: number
} = (repairOrderId) => {
  const { accessToken, shopId } = useAccessTokenAndShopId()

  const { data: authorizations } = useListAuthorizationsQuery({
    authorization: accessToken,
    shop: shopId,
    repairOrder: [repairOrderId]
  })

  return useAuthorizations(authorizations)
}

export default useAuthorizationsById
